import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import ESignTemplateService from "@/core/services/ESignTemplateService";


@Module
export default class ESignTemplateModule extends VuexModule {
  page: any = {
    loading: true,
    data: {
      total: 0,
      data: [],
      pages: 0,
    }
  }

  @Action
  [Actions.LOAD_ESIGN_TEMPLATES](filter:any) {
    ESignTemplateService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_ESIGN_TEMPLATES, {loading: false, data: res})
    })
  }

  @Mutation
  [Mutations.SET_ESIGN_TEMPLATES](payload:any) {
    this.page.loading = payload.loading;
    this.page.data = payload.data;
  }


}